<div class="kx-accessibility-panel" id="accessibilityPanel" [class.kx-open]="accessibilityService.isPanelOpen()">

    <!-- <div class="kx-panel-header">
        <h3>Accessibility <span class="kx-shortcut-hint">Ctrl+U</span></h3>
    </div> -->

    <div class="kx-panel-content">

        <div class="kx-grid">

            @for (card of cards; track card.feature) {
                <div class="kx-card kx-relative"
                     [class.kx-card-active]="showCardBadge(card)"
                     (click)="onCardClick(card)"
                     role="button"
                     tabindex="0"
                     [attr.aria-pressed]="card.controlType === 'toggle' ? isCardActive(card) : null"
                     (keydown.enter)="onCardClick(card)">

                    @if (showCardBadge(card)) {
                        <span class="kx-card-badge" [class.kx-card-badge-saving]="isCardSaving(card)"
                              [attr.aria-label]="isCardSaving(card) ? 'Saving' : 'Active'">
                            @if (isCardSaving(card)) {
                                <span class="kx-card-spinner"></span>
                            } @else {
                                <span class="kx-check-mark">&#10003;</span>
                            }
                        </span>
                    }

                    <i class="fa-solid fa {{ card.icon }}"></i>
                    <span>{{ card.label }}</span>

                    <!-- Step controls: Bigger Text, Text Spacing, Letter Spacing, Line Height,
                         Saturation, Brightness, Cursor Size, Zoom -->
                    @if (card.controlType === 'step') {
                        <div class="kx-step-controls">
                            <button type="button" class="kx-step-btn"
                                    (click)="onDecrement(card, $event)"
                                    aria-label="Decrease {{ card.label }}">−</button>
                            <span class="kx-step-value">{{ getStepValue(card.key) }}</span>
                            <button type="button" class="kx-step-btn"
                                    (click)="onIncrement(card, $event)"
                                    aria-label="Increase {{ card.label }}">+</button>
                        </div>
                    }

                    <!-- Theme mode: Light / Dark / Auto -->
                    @if (card.controlType === 'theme') {
                        <div class="kx-option-row" (click)="$event.stopPropagation()">
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().themeMode === ThemeMode.Light"
                                    (click)="accessibilityService.setThemeMode(ThemeMode.Light)">Light</button>
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().themeMode === ThemeMode.Dark"
                                    (click)="accessibilityService.setThemeMode(ThemeMode.Dark)">Dark</button>
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().themeMode === ThemeMode.Auto"
                                    (click)="accessibilityService.setThemeMode(ThemeMode.Auto)">Auto</button>
                        </div>
                    }

                    <!-- Text alignment -->
                    @if (card.controlType === 'textAlign') {
                        <div class="kx-option-row" (click)="$event.stopPropagation()">
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().textAlign === TextAlignMode.Left"
                                    (click)="accessibilityService.setTextAlign(TextAlignMode.Left)">
                                <i class="fa-solid fa-align-left"></i>
                            </button>
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().textAlign === TextAlignMode.Center"
                                    (click)="accessibilityService.setTextAlign(TextAlignMode.Center)">
                                <i class="fa-solid fa-align-center"></i>
                            </button>
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().textAlign === TextAlignMode.Right"
                                    (click)="accessibilityService.setTextAlign(TextAlignMode.Right)">
                                <i class="fa-solid fa-align-right"></i>
                            </button>
                            <button type="button" class="kx-option-btn"
                                    [class.kx-option-active]="accessibilityService.settings().textAlign === TextAlignMode.Justify"
                                    (click)="accessibilityService.setTextAlign(TextAlignMode.Justify)">
                                <i class="fa-solid fa-align-justify"></i>
                            </button>
                        </div>
                    }

                    <!-- Font family selector -->
                    @if (card.controlType === 'fontFamily') {
                        <select class="kx-select primary-btn" (click)="$event.stopPropagation()"
                                (change)="accessibilityService.setFontFamily($any($event.target).value)">
                            <option [value]="FontFamilyOption.Default" [selected]="accessibilityService.settings().fontFamily === FontFamilyOption.Default">Default</option>
                            <option [value]="FontFamilyOption.SansSerif" [selected]="accessibilityService.settings().fontFamily === FontFamilyOption.SansSerif">Sans Serif</option>
                            <option [value]="FontFamilyOption.Serif" [selected]="accessibilityService.settings().fontFamily === FontFamilyOption.Serif">Serif</option>
                            <option [value]="FontFamilyOption.Monospace" [selected]="accessibilityService.settings().fontFamily === FontFamilyOption.Monospace">Monospace</option>
                            <option [value]="FontFamilyOption.Dyslexic" [selected]="accessibilityService.settings().fontFamily === FontFamilyOption.Dyslexic">Dyslexic</option>
                        </select>
                    }

                    <!-- Cursor color picker -->
                    @if (card.controlType === 'cursorColor') {
                        <div class="kx-option-row" (click)="$event.stopPropagation()">
                            @for (color of [CursorColorOption.Black, CursorColorOption.White, CursorColorOption.Yellow, CursorColorOption.Blue]; track color) {
                                <button type="button" class="kx-color-swatch" [attr.data-color]="color"
                                        [class.kx-option-active]="accessibilityService.settings().cursorColor === color"
                                        [attr.aria-label]="color"
                                        (click)="accessibilityService.setCursorColor(color)"></button>
                            }
                        </div>
                    }

                </div>
            }

        </div>
        <div class="d-flex justify-content-center gap-2 pt-3">
        <button type="button" class="primary-btn" (click)="resetAll()">
            <i class="fa-solid fa fa-refresh"></i> Reset All
        </button>
        </div>

    </div>

</div>